export const ERROR_MSG = {
    
    For_60_Char :'Max 60 characters are allowed',
    For_30_char : 'Max 30 characters are allowed',
    PARCEL_WEIGHT_EXCEEDED: 'Parcel weight exceeded. Parcel weight limit is {weight}kg for delivery address',
    WEIGHT_REQUIRED: 'Weight field is required',
    WEIGHT_OUTSIDE_PERMITTED_RANGE: 'Weight is outside permitted range',
    MUST_VALUE_BETWEEN_ONE_TO: 'Must be a value between 1 to',
    EMAIL_REQUIRED: 'Email address is required',
    CUSTOMER_NOT_FOUND: 'Customer not found',
    CUSTOMERS_ADDRESS_SEARCH: 'Customer’s address search',
    COLLECTION_SAVED: 'Collection saved successfully',
    ERROR_IN_CREATING_COLLECTION: 'Error in creating collection :',
    SERVICE_POINT_REQUIRED: 'ServicePoint  is required',
    FORM_ERROR: 'The form has errors, please correct and try again',
    CUSTOMER_SAVED_ADDRESSBOOK: 'Customer details saved successfully in addressbook',
    ERROR_WHILE_SAVING_CUSTOMER_DETAILS: 'Error occurred while saving customer details',
    CUSTOMER_DETAILS_SAVED_FAVOURITE:'Customer details saved in favourites',
    NOT_ADD_ITEM_TO_FAVOURITE:'Could not add items to favourites.',
    CREATE_LABEl_MSG:'Create & email label successful. Shipment number :',
    COLLECTION_SAVED_MSG:'Collection created successfully. Shipment number:',
    ERROR_OCCUR_WHILE_CREATING_COLLECTION:'Error occurred while creating collection, please try again'
  };